import { COPILOT_DELEGATION_TOOL_NAMES } from "@regal-voice/shared-types";

export function isCopilotDelegationToolName(name: string | null | undefined): boolean {
    return typeof name === "string" && COPILOT_DELEGATION_TOOL_NAMES.has(name);
}
